import React from "react";
import { Card } from "primereact/card";
import AppBreadcrumb from "../../components/CustomeBreadcrumb/AppBreadcrumb";
import { formatPageDate } from "../../appconfig/TemplateFieldSetting";
import { Link } from "react-router-dom";

const Profile: React.FC = () => {
  // get userdata from local storage
  const rawUserData = localStorage.getItem("user_data");
  let userData: any = null;
  // parse rawuserdata into userData
  userData = rawUserData ? JSON.parse(rawUserData) : null;

  // user role
  const userRole = userData?.roles?.role_name || "";

  return (
    <>
      <AppBreadcrumb
        currentMenu="Profile"
        pageName="Profile"
        pageTitle={
          <>
            <Link to={"/dashboard"}>
              <i className="mr-2 pi pi-arrow-left"></i>
            </Link>
            Profile
          </>
        }
      />

      <Card className="p-0 bg-white" style={{ height: "calc(100% - 52px)" }}>
        <div className="grid">
          {/* Name */}
          <div className="flex mb-3 col-12">
            <div className="">
              <label className="font-bold text-gray-700">{userData?.roles?.role_name === "Client" ? "Company Name" : "Name"}:</label>
              <div className="flex gap-2 align-items-center">
                <h2 className="mt-1 mb-1 text-xl font-semibold text-gray-900">
                  {userData?.first_name ?? ""} {userData?.last_name ?? ""} {userData?.company_name ?? ""}
                </h2>
              </div>
            </div>
          </div>

          {/* Right: Details */}
          <div className="col-12 md:col-12">
            <div className="grid p-fluid">
              {/* Email */}
              {!window.cn(userData?.email) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label className="font-bold text-gray-700">Email:</label>
                  <div className="text-gray-900">{userData?.email || "-"}</div>
                </div>
              )}

              {/* Phone */}
              {!window.cn(userData?.phone) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label className="font-bold text-gray-700">Phone:</label>
                  <div className="text-gray-900">{userData?.phone || "-"}</div>
                </div>
              )}

              {/* joining date */}
              {!window.cn(userData?.joining_date) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label className="font-bold text-gray-700">Joining Date:</label>
                  <div className="text-gray-900">{userData?.joining_date ? formatPageDate(userData?.joining_date) : "-"}</div>
                </div>
              )}

              {/* DOB */}
              {!window.cn(userData?.date_of_birth) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label className="font-bold text-gray-700">Date Of Birth:</label>
                  <div className="text-gray-900">{userData?.date_of_birth ? formatPageDate(userData?.date_of_birth) : "-"}</div>
                </div>
              )}

              {/* Client Change */}
              {!window.cn(userData?.client_charge) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label className="font-bold text-gray-700">Client Payment:</label>
                  <div className="text-gray-900">{userData?.client_charge || "-"}</div>
                </div>
              )}

              {/* Business no */}
              {!window.cn(userData?.bussiness_number) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label style={{ fontWeight: "bold" }}>Business No:</label>
                  <div>{userData?.bussiness_number || "-"}</div>
                </div>
              )}

              {/* Display data for employee */}
              {userData?.roles?.role_name === "Employee" && (
                <>
                  {!window.cn(userData?.vacation_hold) && (
                    <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                      <label style={{ fontWeight: "bold" }}> Is Vacation Payout On Hold:</label>
                      <div>{userData?.vacation_hold === true ? "Yes" : "No"}</div>
                    </div>
                  )}

                  {!window.cn(userData?.vaccation_payout) && (
                    <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                      <label style={{ fontWeight: "bold" }}>Vacation Payout:</label>
                      <div>{userData.vaccation_payout ? `${userData.vaccation_payout}%` : "-"}</div>
                    </div>
                  )}

                  {!window.cn(userData?.supervisor) && (
                    <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                      <label style={{ fontWeight: "bold" }}>Supervisor:</label>
                      <div>
                        {" "}
                        {userData?.user?.first_name} {userData?.user?.last_name}
                      </div>
                    </div>
                  )}

                  {!window.cn(userData?.ei_exempt) && (
                    <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                      <label style={{ fontWeight: "bold" }}>Is EI Exempt:</label>
                      <div>{userData?.ei_exempt === true ? "Yes" : "No"}</div>
                    </div>
                  )}

                  {!window.cn(userData?.cpp_exempt) && (
                    <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                      <label style={{ fontWeight: "bold" }}>Is CPP Exempt:</label>
                      <div>{userData?.cpp_exempt === true ? "Yes" : "No"}</div>
                    </div>
                  )}
                </>
              )}

              {/* Sin number */}
              {!window.cn(userData?.sin_number) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label style={{ fontWeight: "bold" }}>SIN No:</label>
                  <div>{userData?.sin_number || "-"}</div>
                </div>
              )}

              {!window.cn(userData?.address) && userRole === "Employee" ? (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label className="font-bold text-gray-700">Street Address:</label>
                  <div className="text-gray-900">{userData?.address || "-"}</div>
                </div>
              ) : (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label className="font-bold text-gray-700">Address:</label>
                  <div className="text-gray-900">{userData?.address || "-"}</div>
                </div>
              )}

              {!window.cn(userData?.city) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label className="font-bold text-gray-700">City:</label>
                  <div className="text-gray-900">{userData?.city || "-"}</div>
                </div>
              )}

              {!window.cn(userData?.province) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label className="font-bold text-gray-700">Province:</label>
                  <div className="text-gray-900">{userData?.province || "-"}</div>
                </div>
              )}

              {!window.cn(userData?.postal_code) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label className="font-bold text-gray-700">Postal Code:</label>
                  <div className="text-gray-900">{userData?.postal_code || "-"}</div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Card>
    </>
  );
};

export default Profile;
